"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var If = function If(_ref) {
  var cond = _ref.cond,
      children = _ref.children,
      inline = _ref.inline,
      style = _ref.style,
      className = _ref.className,
      component = _ref.component;

  var childrenLength = _react.default.Children.toArray(children).length;

  if (!cond) {
    return null;
  }

  if (!className && !style && !component && !inline) {
    return children;
  }

  console.warn('Using className, style, component or inline props in If component is deprecated. In future versions, the If component would only return the children.');

  if (component) {
    return _react.default.createElement(component, {
      style: style,
      className: className
    });
  }

  if (childrenLength === 1) {
    return _react.default.cloneElement(children);
  }

  if (inline) {
    return _react.default.createElement("span", {
      style: style,
      className: className
    }, children);
  } else {
    return _react.default.createElement("div", {
      style: style,
      className: className
    }, children);
  }
};

var _default = If;
exports.default = _default;